import { Box, styled } from '@mui/material';
import color from 'src/theme/color';

export const Body = styled(Box)`
    display: flex;
    flex-direction: column;
    padding-top: 12px;
`;

export const DescriptionText = styled(Box)({
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    color: color.white70
});

export const RichTextEditor = styled('div')`
    margin-top: 12px;
`;

export const AttachmentsContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    maxHeight: '150px',
    overflowY: 'auto',
    width: '100%',
    padding: '8px 0',
    marginTop: '12px'
});

export const AttachmentIconButton = styled(Box)({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '4px',
    marginRight: '4px'
});

export const HiddenFileInput = styled('input')({
    display: 'none'
});

export const ErrorMessage = styled(Box)({
    color: color.errorRed,
    fontSize: '12px',
    width: '100%',
    marginTop: '8px'
});

export const Footer = styled(Box)`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 16px;
`;
